<template>
  <div class="mt-2">
    <b-row class="justify-content-start align-items-center">
      <b-col v-for="(link, n) in links" :key="n" cols="4" v-if="checkIsItemGroup(link)">
        <b-card style="height: 260px">
          <b-card-title class="mb-3 d-flex align-items-center">
            <feather-icon size="16" class="mr-50" icon="GridIcon" />
            {{ link.title }}
          </b-card-title>

          <b-form-row class="mt-5">
            <b-col
              v-for="(btn, n) in link.btns"
              :key="n"
              v-if="checkIsItem(btn.slug)" 
              cols="4"
              v-can="{ slug: btn.slug, action: 'S' }"
            >
            
              <router-link :to="btn.path">
                <div
                  class="ngos-link d-flex flex-column align-items-center px-1"
                >
                  <feather-icon class="my-1" size="45" :icon="btn.icon" />

                  <h5 style="white-space: pre-line" class="text-white">
                    {{ btn.label }}
                  </h5>
                </div>
              </router-link>
            </b-col>
          </b-form-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import AuthHelpers from "@/utils/auth-helpers";
import {
  BRow,
  BFormRow,
  BContainer,
  BCol,
  BAvatar,
  BCard,
  BCardTitle,
  BCardText,
  BButton,
} from "bootstrap-vue";

export default {
  components: {
    BRow,
    BFormRow,
    BContainer,
    BCol,
    BAvatar,
    BCard,
    BCardTitle,
    BCardText,
    BButton,
  },

  data() {
    return {
      links: [
        {
          title: "إدارة المنظمات",
          btns: [
            {
              slug: "ministry_immediate_ngos",
              label: "جدول المنظمات",
              path: { name: "settings-ngos-management" },
              icon: "GridIcon",
            },
            {
              slug: "ministry_ngos_validation",
              label: "تدقيق المنظمات",
              path: { name: "settings-ngos-validation" },
              icon: "CheckSquareIcon",
            },
            {
              slug: "ministry_ngos_validation_report",
              label: "تقرير التدقيق",
              path: { name: "settings-ngos-validation-report" },
              icon: "PieChartIcon",
            },
          ],
        },
        {
          title: "التواصل مع المنظمات",
          btns: [
            {
              slug: "ngo_messages",
              label: "المراسلات",
              path: { name: "messaging", params: { folder: "received" } },
              icon: "MailIcon",
            },
            {
              slug: "ministry_incentives_management_comm",
              label: "الثناءات و العقوبات",
              path: { name: "communication-incentives" },
              icon: "AwardIcon",
            },
            {
              slug: "ministry_accept_reject_campaigns_comm",
              label: "حملات التبرع",
              path: { name: "communication-campaigns" },
              icon: "TrendingUpIcon",
            },
          ],
        },
        {
          title: "المعاملات",
          btns: [
            {
              slug: "ministry_mediation_request",
              label: "معاملات التوسّط",
              path: { name: "settings-mediation-requestes" },
              icon: "GridIcon",
            },
            {
              slug: "ministry_financial_grants",
              label: "طلبات المنح المالية",
              path: { name: "settings-financial-grants" },
              icon: "GridIcon",
            },
          ],
        },

      ],
    };
  },
  methods: {
    checkIsItem(slug) {
      return AuthHelpers.canNavigate(slug);
    },
    checkIsItemGroup(item) {
      return item.btns.some((el) => AuthHelpers.canNavigate(el.slug));
    },

  },
};
</script>

<style lang="scss" scoped>
.ngos-link {
  background-color: var(--primary);
  padding: 4px;
  color: var(--white);
  text-align: center;
  white-space: nowrap;
  margin-bottom: 15px;
  padding: 10px;
  border-radius: 10px;
  transition: all 0.25s ease;

  &:hover {
    opacity: 0.85;
    -webkit-box-shadow: 0 8px 25px -8px var(--primary);
    box-shadow: 0 8px 25px -8px var(--primary);
  }

  &:active {
    background-color: #043d6e;
  }
}
</style>
